import { MIXPANEL_EVENTS } from 'lib/mixpanel/events'
import { trackMixpanelEvent } from 'lib/mixpanel/track'
import { FunnelSimple } from 'phosphor-react'
import { useDispatch, useSelector } from 'react-redux'
import styled from 'styled-components'

import { collapse, updateFilter } from 'redux/modules/filters'

import { useUser } from 'providers/UserProvider'

import { Button } from 'components/v2/Button'
import { Row, Column } from 'components/v2/Grid'
import TypeaheadSelect from 'components/v2/MoreFilters/TypeheadSelect'
import { RangeSlider } from 'components/v2/RangeSlider'
import { Text } from 'components/v2/Text'

import 'react-dates/initialize'

const TopFilters = ({ onSearchPsychologists = () => {} }) => {
	const dispatch = useDispatch()
	const { shouldHideConsultationValue } = useUser()
	const filters = useSelector((state) => state.filters)
	const psychologists = useSelector((state) => state.psychos)

	const onChangeConsultationPriceRange = ([min_price, max_price]) =>
		dispatch(updateFilter({ min_price, max_price }))

	const onToggleMoreFiltersVisibility = () => {
		if (!filters?.collapsed) {
			trackMixpanelEvent(MIXPANEL_EVENTS.search.filter_shown)
		}
		dispatch(collapse())
	}

	return (
		<Column>
			<Container>
				<Row className='w-full flex-col gap-6 sm:flex-row'>
					<TypeaheadSelect
						title='Especialidade ou transtorno'
						emptyLabel='Nenhuma sugestão encontrada'
						placeholder='Como Ansiedade, Depressão, TDAH'
						showMoreLabel='Mostrar mais resultados...'
					/>
					{!shouldHideConsultationValue && (
						<Column className='w-full'>
							<Text variant='tiny' className='mb-1.5 text-left font-normal'>
								Valor da consulta
							</Text>
							<Row className='items-center'>
								<Text
									variant='regular'
									className='w-1/4 text-left font-normal text-orange-600'
								>
									{`R$ ${filters?.min_price}`}
								</Text>

								<Row className='w-full'>
									<RangeSlider
										range
										min={50}
										max={350}
										value={[filters?.min_price, filters?.max_price]}
										onChange={onChangeConsultationPriceRange}
										allowCross={false}
										pushable={9}
									/>
								</Row>

								<Text
									variant='regular'
									className='w-1/4 text-right font-normal text-orange-600'
								>
									{`R$ ${filters?.max_price}`}
								</Text>
							</Row>
						</Column>
					)}
				</Row>
				<Row id='top-filters' className='search-buttons justify-between'>
					<Filter onClick={onToggleMoreFiltersVisibility}>
						<Text
							className='ml-2.5 whitespace-nowrap font-semibold text-orange-600'
							variant='small'
						>
							Mais filtros
						</Text>
						<FunnelSimple size={22} color='#FF7708' weight='bold' />
					</Filter>
					<Button
						className='h-[51px] w-full min-w-[154px] rounded-[10px] text-sm font-semibold'
						onClick={onSearchPsychologists}
						disabled={psychologists?.loading}
						data-toggle='collapse'
						data-target='#collapseSearchFilters'
						aria-expanded='false'
						aria-controls='collapseSearchFilters'
						name='button'
						id='search-button'
					>
						Buscar
					</Button>
				</Row>
			</Container>
		</Column>
	)
}

export default TopFilters

const Container = styled(Row)`
	justify-content: space-between;
	gap: 16px;
	min-width: 1120px;
	padding-bottom: 18px;
	@media (max-width: 992px) {
		min-width: 300px;
		flex-direction: column;
		margin: 0 10px;
	}
`
const Filter = styled.button`
	background: transparent;
	border: 1px solid #ff7708;
	border-radius: 10px;
	font-size: 14px;
	font-weight: bold;
	height: 51px;
	min-width: 154px;
	width: 100%;
	display: flex;
	gap: 10px;
	margin-right: 18px;
	justify-content: center;
	align-items: center;
	padding: 0 15px;
	@media (max-width: 770px) {
		margin-right: 10px;
		padding: 0 0;
	}
	@media (max-width: 320px) {
		margin-right: 5px;
	}
`
